export default __webpack_public_path__ + "static/media/suppliermap.73ebcaf1.svg";